__turbopack_context__.v({
  "closeButton": "anc-Uq_closeButton",
  "inCartDrawer": "anc-Uq_inCartDrawer",
  "itemsWrapper": "anc-Uq_itemsWrapper",
  "separator": "anc-Uq_separator",
  "titleRow": "anc-Uq_titleRow",
});
